import type { AxiosResponse } from 'axios'
import { marketplaceApiVersionPrefix, marketplaceClient } from '../client'

export async function getMediaFileInfo(mediaFileUuid: string): Promise<AxiosResponse> {
  return await marketplaceClient.get(
    `${marketplaceApiVersionPrefix}/shop/media-files/${mediaFileUuid}`
  )
}
